import { renderToString } from "katex";

export const decodeEntities = (value?: string) => {
  const element = document.createElement("div");
  element.innerHTML = value?.trim() ?? "";
  const text = element.innerText;

  return text;
};

const FORMULA_REGEX = /\$([\s\S]*?)\$/g;

export const processValue = async (value?: string) => {
  if (!value) return "";

  try {
    return Promise.resolve(
      value.replace(FORMULA_REGEX, (_, content) => {
        const formula = decodeEntities(content);

        const result = renderToString(formula, {
          throwOnError: false,
          displayMode: false,
        }).replace(/(>)([^<]*?)(\d+)\.(\d+)([^<]*?)(<)/g, "$1$2$3٫$4$5$6");

        return result;
      }),
    );
  } catch (error) {
    console.error("Worker failed to process KaTeX:", error);

    return value;
  }
};
